<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-chair_bk.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">クラス管理</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'home' }">戻る</router-link>
    </div>
    <div class="container">
      <!--tab-->
      <ul class="nav nav-tabs">
        <li class="nav-item" id="tabmenu">
          <a class="nav-link active tabitem">クラス</a>
        </li>
      </ul>

      <form class="form-inline">
        <button type="button" class="btn-sm" @click="createNewTamaiClass">
          新規登録
        </button>
      </form>

      <button type="button" class="btn btn-gray" @click="exportToExcel">
        エクスポート
      </button>
      <button type="button" class="btn btn-gray" @click="exportToPdf">プリント</button>
      <button type="button" class="btn btn-gray" @click="displayColumns">
        表示項目選択
      </button>
      <div class="form-group float-right">
        <label for="text1">検索:</label>
        <input type="text" id="searchform_small" class="form-control" v-model="filter" />
      </div>

      <form class="form-inline showall">
        <div class="form-sort align-items-center">
          <div class="item-count col-2 my-1">
            <label class="mr-sm-2 sr-only" for="inlineFormCustomSelectSmall">
              Preference
            </label>
            <select class="custom-select mr-sm-2" id="inlineFormCustomSelectSmall" v-model="perPage">
              <option :value="totalTamaiClasses" selected>全</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
              <option :value="150">150</option>
            </select>
            件表示
          </div>
        </div>
      </form>

      <div class="tab-content">
        <div id="table-1" class="tab-pane active">
          <div class="table-wrapper-scroll-y">
            <b-table
              ref="class-table"
              :min-width="tableWidth"
              class="sticky-table table-auto-height"
              selectable
              responsive
              sticky-header
              :items="tamai_class.tamaiClasses"
              :fields="filteredHeaders"
              :filter="filter"
              :filterIncludedFields="searchableFields"
              :per-page="perPage"
              :current-page="currentPage"
              :refreshed="tableRefreshed()"
            >
              <template v-slot:head()="scope">
                <div class="text-nowrap">
                  <b>{{ scope.label }}</b>
                </div>
              </template>

              <template v-slot:head(selected)>
                <b-form-checkbox @input="toggleSelectAll" v-model="selectAll" />
              </template>

              <template v-slot:cell(selected)="row">
                <b-form-checkbox @input="selectRow($event, row.index)" v-model="row.rowSelected" />
              </template>

              <template v-slot:cell(name)="row">
                <router-link :to="{ name: 'class-id-detail', params: { id: row.item.id } }">
                  {{ row.value }}
                </router-link>
              </template>

              <template v-slot:cell(testPassingScore)="row"> {{ row.value }}点 </template>

              <template v-slot:cell(frozenStatus)="row">
                <div class="b-table-column-background-white">
                  <router-link :to="{ name: 'class-id-frozen', params: { id: row.item.id } }">
                    {{ frozenStatus(row.value) }}
                  </router-link>
                </div>
              </template>
            </b-table>
          </div>
          <div class="pagination-footer">
            <label> {{ totalTamaiClasses }} 件中 {{ baseIndex }} から {{ capIndex }} まで表示 </label>
            <div class="float-right">
              <button :disabled="!hasPreviousPage" type="button" class="btn btn-invisible" @click="goToPreviousPage">
                前
              </button>
              <label class="pagination-border text-center">{{ currentPage }}</label>
              <button :disabled="!hasNextPage" type="button" class="btn btn-invisible" @click="goToNextPage">
                次
              </button>
            </div>
          </div>
        </div>
      </div>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="OK"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header>表示する項目を選択してください</template>
        <template v-slot:body>
          <thead>
            <tr v-for="field in customHeaders" :key="field.key">
              <th scope="row">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" :id="field.key" v-model="field.enable" />
                  <label class="custom-control-label" :for="field.key">
                    {{ field.label }}
                  </label>
                </div>
              </th>
            </tr>
          </thead>
        </template>
      </PopUpHolder>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import store from '@/store/index.js';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import EventBus from '@/helpers/EventBus.js';
import { sumObjectArrayByKey } from '@/utils/math_helpers.js';
import { updateTableHeight } from '@/helpers/table';
import { updateStickyColumnsAndMinWidth } from '@/helpers/sticky_table';
import { basicFrozenStatus, basicFieldPresent } from '@/presenters/fields';
import XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import { buildJapaneseFont } from '@/helpers/PdfCustomFont.js';

export default {
  components: {
    PopUpHolder,
  },
  data() {
    var fields = [
      {
        key: 'selected',
        sortable: false,
        hidable: false,
        enable: true,
        searchable: false,
        class: 'sticky-column left-sticky-column-1',
        thAttr: { width: 20 },
      },
      {
        key: 'corporation',
        label: '法人名',
        sortable: true,
        hidable: true,
        enable: false,
        searchable: true,
        thAttr: { width: 150 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return basicFieldPresent(value, 'name');
        },
      },
      {
        key: 'brand',
        label: 'ブランド名',
        sortable: true,
        hidable: true,
        enable: false,
        searchable: true,
        thAttr: { width: 150 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return basicFieldPresent(value, 'name');
        },
      },
      {
        key: 'school',
        label: '教場名',
        sortable: true,
        hidable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 150 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return basicFieldPresent(value, 'name');
        },
      },
      {
        key: 'course',
        label: 'コース名',
        sortable: true,
        hidable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 150 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return basicFieldPresent(value, 'name');
        },
      },
      {
        key: 'uid',
        label: 'クラスID（自動生成）',
        sortable: true,
        hidable: true,
        enable: false,
        searchable: true,
        thAttr: { width: 200 },
      },
      {
        key: 'name',
        label: 'クラス名',
        sortable: true,
        hidable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 150 },
      },
      {
        key: 'mainTeacher',
        label: '先生名（担当・メイン）',
        sortable: true,
        hidable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 250 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return basicFieldPresent(value, 'name');
        },
      },
      {
        key: 'teacher1',
        label: '先生名（担当・サブ1）',
        sortable: true,
        hidable: true,
        enable: false,
        searchable: true,
        thAttr: { width: 250 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return basicFieldPresent(value, 'name');
        },
      },
      {
        key: 'teacher2',
        label: '先生名（担当・サブ2）',
        sortable: true,
        hidable: true,
        enable: false,
        searchable: true,
        thAttr: { width: 250 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return basicFieldPresent(value, 'name');
        },
      },
      {
        key: 'teacher3',
        label: '先生名（担当・サブ3）',
        sortable: true,
        hidable: true,
        enable: false,
        searchable: true,
        thAttr: { width: 250 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return basicFieldPresent(value, 'name');
        },
      },
      {
        key: 'teacher4',
        label: '先生名（担当・サブ4）',
        sortable: true,
        hidable: true,
        enable: false,
        searchable: true,
        thAttr: { width: 250 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return basicFieldPresent(value, 'name');
        },
      },
      {
        key: 'teacher5',
        label: '先生名（担当・サブ5）',
        sortable: true,
        hidable: true,
        enable: false,
        searchable: true,
        thAttr: { width: 250 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return basicFieldPresent(value, 'name');
        },
      },
      {
        key: 'teacher6',
        label: '先生名（担当・サブ6）',
        sortable: true,
        hidable: true,
        enable: false,
        searchable: true,
        thAttr: { width: 250 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return basicFieldPresent(value, 'name');
        },
      },
      {
        key: 'teacher7',
        label: '先生名（担当・サブ7）',
        sortable: true,
        hidable: true,
        enable: false,
        searchable: true,
        thAttr: { width: 250 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return basicFieldPresent(value, 'name');
        },
      },
      {
        key: 'teacher8',
        label: '先生名（担当・サブ8）',
        sortable: true,
        hidable: true,
        enable: false,
        searchable: true,
        thAttr: { width: 250 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return basicFieldPresent(value, 'name');
        },
      },
      {
        key: 'classSize',
        label: 'クラス人数',
        sortable: true,
        hidable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 150 },
      },
    ];
    if (this.$store.getters['role/hasAdminPrivilege']) {
      fields.push({
        key: 'frozenStatus',
        label: '処理',
        sortable: true,
        hidable: false,
        enable: true,
        searchable: false,
        class: 'sticky-column right-sticky-column-1',
        thAttr: { width: 150 },
      });
    }
    return {
      fields: fields,
      currentPage: 1,
      perPage: 50,
      selectAll: false,
      filter: null,
    };
  },
  mounted() {
    EventBus.$on('SESSION_RESTORED', this.eventHandler);

    // 登録・編集の入力情報を初期化
    this.clearEditingTamaiClass();
    this.$store.dispatch('form/clearFormDataStored');
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store.dispatch('tamai_class/fetchTamaiClasses', {}).then(() => {
      next();
    });
  },
  beforeDestroy() {
    EventBus.$off('SESSION_RESTORED', this.eventHandler);
  },
  computed: {
    baseIndex() {
      return (this.currentPage - 1) * this.perPage + 1;
    },
    capIndex() {
      return Math.min(this.baseIndex + this.perPage - 1, this.totalTamaiClasses);
    },
    hasPreviousPage() {
      return this.currentPage > 1;
    },
    hasNextPage() {
      return this.totalTamaiClasses > this.currentPage * this.perPage;
    },
    customHeaders() {
      return this.fields.filter((field) => field.hidable == true);
    },
    filteredHeaders() {
      return this.fields.filter((field) => field.enable == true);
    },
    searchableFields() {
      var fields = this.fields.filter((field) => field.enable == true && field.searchable == true);
      return fields.map((field) => field.key);
    },
    tableWidth() {
      return sumObjectArrayByKey(this.filteredHeaders, 'thAttr', 'width') + 'px';
    },
    selectedFieldLabels() {
      const filteredFields = this.fields.filter(
        (field) => field.enable == true && field.label && field.key != 'frozenStatus'
      );
      return filteredFields.map((field) => field.label);
    },
    ...mapState(['tamai_class']),
    ...mapGetters('tamai_class', ['totalTamaiClasses', 'getExcelFormattedTamaiClasses']),
  },
  methods: {
    tableRefreshed() {
      this.$logger.debug('Table refreshed');
      updateTableHeight();
      updateStickyColumnsAndMinWidth({ leftColumns: 1, rightColumns: 1 });
    },
    displayColumns() {
      this.$logger.debug('Display Columns for Tamai Classes');
      this.$refs['popup_holder'].show();
    },
    createNewTamaiClass() {
      this.$router.push({ name: 'class-add' });
    },
    popupConfirmed() {
      this.$logger.debug('Popup done');
    },
    goToPreviousPage() {
      this.selectAll = false;
      this.currentPage--;
    },
    goToNextPage() {
      this.selectAll = false;
      this.currentPage++;
    },
    toggleSelectAll(checked) {
      if (checked) {
        this.$refs['class-table'].selectAllRows();
      } else {
        this.$refs['class-table'].clearSelected();
      }
    },
    selectRow(checked, index) {
      if (checked) {
        this.$refs['class-table'].selectRow(index);
      } else {
        this.$refs['class-table'].unselectRow(index);
      }
    },
    eventHandler(payload) {
      if (payload.hasAdminPrivilege && this.fields.filter((item) => item.key === 'frozenStatus').length == 0) {
        this.fields.push({
          key: 'frozenStatus',
          label: '処理',
          sortable: true,
          hidable: false,
          enable: true,
          searchable: false,
          class: 'sticky-column right-sticky-column-1',
          thAttr: { width: 150 },
        });
      }
    },
    frozenStatus(field) {
      return basicFrozenStatus(field);
    },
    exportToExcel() {
      this.$logger.debug('Export Classes to Excel');
      let data = this.getExcelFormattedTamaiClasses(this.selectedFieldLabels);
      var classWS = XLSX.utils.json_to_sheet(data);
      var wb = XLSX.utils.book_new(); // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, classWS, 'Classes'); // add Worksheet to Workbook
      XLSX.writeFile(wb, 'classes.xlsx');
    },
    createHeaders(keys, columnWidth) {
      return keys.map((key) => ({
        name: key,
        prompt: key,
        width: columnWidth,
        align: 'left',
        padding: 0,
      }));
    },
    exportToPdf() {
      this.$logger.debug('Print Classes to PDF');
      let doc = new jsPDF({ orientation: 'l', format: 'a4' });
      buildJapaneseFont(doc);
      this.$logger.debug('calling getExcelFormattedTamaiClasses', this.selectedFieldLabels);
      let data = this.getExcelFormattedTamaiClasses(this.selectedFieldLabels);
      let pdfPageWidth = doc.internal.pageSize.getWidth();

      // Setting the actual pdfPageWidth doesn't fill the entire page,
      // so use a bigger number as a workaround when there are many columns.
      let paddingWidth = 4;
      if (this.selectedFieldLabels.length > 6) {
        pdfPageWidth = 390;
        paddingWidth = 2;
      }
      let columnWidth = (pdfPageWidth - paddingWidth * 2) / this.selectedFieldLabels.length;
      this.$logger.debug('data', data[0], Object.keys(data[0]).length, this.selectedFieldLabels.length);
      doc.table(paddingWidth, 6, data, this.createHeaders(this.selectedFieldLabels, columnWidth));
      doc.autoPrint();
      if (data.length > 50) {
        this.$logger.debug('Data too big, can only save');
        doc.save('classes.pdf', { returnPromise: true }).then(() => {
          this.$logger.debug('PDF saved successfully');
        });
      } else {
        this.$logger.debug('Data OK, Print from new window');
        doc.output('dataurlnewwindow', { filename: 'classes.pdf' });
      }
    },
    ...mapActions('tamai_class', ['clearEditingTamaiClass']),
  },
};
</script>

<style scoped>
.btn-sm {
  margin-left: 0px;
}
.btn-gray {
  margin-bottom: 5px;
}
.item-count {
  padding: 0;
  font-size: 10px;
}
.custom-control-label {
  font-weight: normal;
}
.pagination-footer {
  margin-top: 20px;
}
</style>
